export default __webpack_public_path__ + "static/media/larvia-logo-light.c1234241.png";